// eslint-disable-next-line import/prefer-default-export
export const BOOKING_PARAMS = "BOOKING_PARAMS";
